module.exports = "<ul class=\"none-style-list\">\n  <li>\n    <strong *ngIf=\"node.id==selectedNodeId\">{{node.name}}</strong>\n    <a *ngIf=\"node.id!=selectedNodeId\" routerLink=\"/serviceObject/{{node.id}}\">{{node.name}}</a>\n    <serviceObject-tree-node *ngFor=\"let node of node.children\" [node]=\"node\" [selectedNodeId]=\"selectedNodeId\"></serviceObject-tree-node>\n  </li>\n</ul>\n\n\n"


//////////////////
// WEBPACK FOOTER
// /app/SPA/src/app/client/components/serviceObject/tree-node/serviceObject-tree-node.component.html
// module id = ../../../../../src/app/client/components/serviceObject/tree-node/serviceObject-tree-node.component.html
// module chunks = 0